import type { ReactNode } from "react";

import { AnimatedScreen } from "@/components/AnimatedScreen/AnimatedScreen";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

// AnimatedScreen is a full-height page shell (h-full + pt-[100px]). Box it in a
// bordered, scrollable frame so each variant is viewable side by side without
// each one eating the whole viewport.
function Frame({ children }: { children: ReactNode }) {
  return (
    <div className="h-[360px] overflow-auto rounded-md border border-border">
      {children}
    </div>
  );
}

const LONG_BODY =
  "We couldn't load this call.\nCheck your connection and try again — the reload button will refresh the page.";

export function PlaygroundAnimatedScreen() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Default (title + multi-line body + reload button)
        </PlaygroundSubSectionTitle>
        <Frame>
          <AnimatedScreen title="Something went wrong">
            {LONG_BODY}
          </AnimatedScreen>
        </Frame>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Without reload button
        </PlaygroundSubSectionTitle>
        <Frame>
          <AnimatedScreen title="Nothing to see here" hasReloadButton={false}>
            This screen has no call-to-action.
          </AnimatedScreen>
        </Frame>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Text first (shouldShowImgFirst = false)
        </PlaygroundSubSectionTitle>
        <Frame>
          <AnimatedScreen
            title="Text before image"
            shouldShowImgFirst={false}
            hasReloadButton={false}
          >
            With shouldShowImgFirst disabled the text block is ordered before
            the animation.
          </AnimatedScreen>
        </Frame>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
